import usePlausible from 'hooks/usePlausible'
import moment from 'moment'
import { memo, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import dashboardApi from 'services/api/dashboard'

import { gotDailyReviews } from '../../../actions/reviews'
import LoyaltyIcon from '../../../components/ReusableComponents/Arrivals/LoyaltyIcon/index'
// import { ReactComponent as NightIcon } from './night.svg'
// import { ReactComponent as RoomIcon } from './room.svg'
import Datepicker from '../../../components/ReusableComponents/Datepicker'
import Dialog from '../../../components/ReusableComponents/Dialog'
import Flag from '../../../components/ReusableComponents/Flag/Flag'
import SmsIcon from '../../../components/ReusableComponents/Icons/Sms'
import LoadingIndicator from '../../../components/ReusableComponents/LoadingIndicator'
import RatingStars from '../../../components/ReusableComponents/RatingStars/index'
import s from './ReviewDetails.module.scss'

const ReviewDetails = ({ dispatch, history, dailyReviews }) => {
  moment.updateLocale(moment.locale(), { invalidDate: 'Unknown' })

  const { postEvent, plausibleEvents } = usePlausible()

  const { date } = useParams()

  const [selectedDate, setSelectedDate] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (selectedDate !== date && !isLoading) {
      getDailyReviews()
    }
  })

  async function getDailyReviews() {
    setIsLoading(true)
    await dashboardApi
      .getDailyReviews(date)
      .then(data => {
        postEvent(plausibleEvents.ViewReviewsForSingleDate, { date })

        setSelectedDate(date)
        dispatch(gotDailyReviews(data.reviewResponses))
        setIsLoading(false)
      })
      .catch(err => {
        if (err.message && err.message === 'No reviews found for date requested') {
          dispatch(gotDailyReviews([]))
          setIsLoading(false)
        }
      })
  }

  function handleChangeDate(date) {
    history.push(`/reviews/${moment(date).format('YYYY-MM-DD')}`)
  }

  return (
    <Dialog>
      {isLoading ? (
        <LoadingIndicator white className={s.loadingIndicator} />
      ) : (
        <DialogHolder>
          <div className={s.datepickerHolder}>
            <Datepicker
              maxDate={new Date()}
              selected={new Date(date)}
              onChange={handleChangeDate}
              className={s.datepicker}
            />
          </div>
          <Modal>
            {dailyReviews.length ? (
              dailyReviews.map(review => <ReviewCard {...review} />)
            ) : (
              <div className={s.noResults}>No reviews found for selected date</div>
            )}
          </Modal>
        </DialogHolder>
      )}
    </Dialog>
  )
}

const DialogHolder = ({ children }) => <div className={s.holder}>{children}</div>

const Modal = ({ children }) => (
  <div className={s.dialog}>
    <div className={s.header}>
      <h1>Reviews and ratings</h1>
      <Link to="/reviews" className={s.close}></Link>
    </div>
    <div className={s.container}>{children}</div>
  </div>
)

const ReviewCard = ({
  rating,
  customerName,
  reviewDetails,
  customerCountryCode,
  loyaltyLevel,
  loyaltyProgram,
  chatId,
  checkIn,
  checkOut
}) => {
  const { postEvent, plausibleEvents } = usePlausible()

  return (
    <div className={s.reviewCard}>
      <div className={s.cardMain}>
        <div className={s.id}>
          <Flag>{customerCountryCode}</Flag>
          <div>
            <p className={s.name}>
              <LoyaltyIcon loyaltyLevel={loyaltyLevel} loyaltyProgram={loyaltyProgram} />
              {customerName}
            </p>
            <p className={s.date}>
              <RatingStars rating={rating} />
            </p>
          </div>
        </div>
        <div className={s.stay}>
          <div className={s.stayItem}>
            <span className={s.label}>Check-in:</span>
            <span className={s.value}>{moment(checkIn).format('MMM DD')}</span>
          </div>
          <div className={s.stayItem}>
            <span className={s.label}>Check-out:</span>
            <span className={s.value}>{moment(checkOut).format('MMM DD')}</span>
          </div>
        </div>
        {chatId && (
          <div
            className={s.rating}
            onClick={() => postEvent(plausibleEvents.StartChatFromReview, { chatId })}
          >
            <Link className={s.button} to={`/feedback/${chatId}`}>
              <SmsIcon /> Message
            </Link>
          </div>
        )}
      </div>
      {reviewDetails && <div className={s.comment}>"{reviewDetails}"</div>}
    </div>
  )
}

const mapStateToProps = ({ reviews: { dailyReviews } }) => ({
  dailyReviews
})

export default connect(mapStateToProps)(memo(ReviewDetails))
